import SettingItemTextV4 from './SettingItemTextV4';
import SettingItemTextWithArrowV4 from './SettingItemTextWithArrowV4';
import Anchor from '../../common/component/Anchor';
import RedDot from '../../common/component/RedDot';
import MoreItemBtnV4 from '../../more/component/MoreItemBtnV4';
import {ISettingItem} from '../type';

interface IProps {
  hasRedDot?: boolean;
  wrapperClassName?: string;
}

export default function SettingItemV4({
  type,
  topText,
  bottomText,
  topTextType = 'main',
  bottomTextType = 'sub',
  pageInfo,
  onClick,
  iconSrc,
  hasRedDot = false,
  wrapperClassName,
  ...props
}: ISettingItem & IProps) {
  return (
    <Anchor pageInfo={pageInfo} onClick={onClick}>
      <div
        className={cn(
          'flex justify-between items-center p-18',
          wrapperClassName
        )}
      >
        <div>
          <div className="flex items-center">
            {iconSrc && <img src={iconSrc} className="w-20 h-20 mr-8" alt="" />}
            <SettingItemTextV4 text={topText} type={topTextType} />
            {hasRedDot && <RedDot className="!static ml-4" />}
          </div>
          {bottomText && (
            <SettingItemTextV4 text={bottomText} type={bottomTextType} />
          )}
        </div>
        <div>
          {type === 'arrow' && (
            <SettingItemTextWithArrowV4
              text={'arrowText' in props ? props.arrowText : undefined}
              arrowType={
                ('arrowType' in props && props.arrowType) || 'onlyArrow'
              }
            />
          )}
          {'btnText' in props && <MoreItemBtnV4 text={props.btnText} />}
        </div>
      </div>
    </Anchor>
  );
}
